import { render, staticRenderFns } from "./TunnelList.vue?vue&type=template&id=65d52fb1&"
import script from "./TunnelList.vue?vue&type=script&lang=js&"
export * from "./TunnelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports